"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportTempApi = exportTempApi;
exports.expressAllApi = expressAllApi;
exports.isLoginApi = isLoginApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function isLoginApi() {
  return Promise.resolve({
    isLogin: false
  });
}

/**
 * 物流公司列表
 */
function expressAllApi(params) {
  return (0, _request.default)({
    url: '/supplier/express/all',
    method: 'get',
    params: params
  });
}

/**
 * 电子面单模板
 */
function exportTempApi(params) {
  return (0, _request.default)({
    url: '/supplier/express/template',
    method: 'get',
    params: params
  });
}